import { TCardContainerAemProp } from '../../model/AemDataProps';
import { Card, CardOrientationEnum, CardTypeEnum, RatioPropEnum } from '../../ui/Card';

export interface ICardContainerProps {
  ratioProp: RatioPropEnum;
  aemCardContainerProps: TCardContainerAemProp;
  orientation?: CardOrientationEnum;
  right?: boolean;
  cardType?: CardTypeEnum;
  buttonType?: string;
  className?: string;
}

export function CardContainer({
  ratioProp,
  aemCardContainerProps,
  cardType,
  buttonType,
  className,
}: ICardContainerProps) {
  return (
    <>
      {aemCardContainerProps.cardsReference.map((content, index) => (
        <Card
          key={`card-${index}`}
          cardAemProp={content}
          cardType={
            aemCardContainerProps.cardType &&
            aemCardContainerProps.cardType === 'Grouped Basic Card' &&
            cardType != CardTypeEnum.Ghost
              ? CardTypeEnum.Default
              : CardTypeEnum.Ghost
          }
          ratioProp={ratioProp}
          // style = {{height: '560px',width:'600px'}}
          buttonType={buttonType}
          className={className}
        />
      ))}
    </>
  );
}
